export const MONTHS_TO_DISPLAY_MOBILE = 2;
